import React from 'react'
import styles from './styles.module.css'


export default function Li ({children, ...props}) {
  return (
    <li className={styles.li} {...props}>{children}</li>
  )
}
